import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    addToCart(product);
  };

  return (
    <Link to={`/product/${product.id}`} className="glass-card" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', height: '100%', padding: 0 }}>
      <div style={{ overflow: 'hidden', borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
        <img
          src={product.image}
          alt={product.name}
          className="product-img-zoom"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </div>
      <div style={{ padding: '1.25rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <h3 className="heading-14" style={{ marginBottom: '0.25rem' }}>{product.name}</h3>

        <p className="text-12" style={{ marginBottom: '1rem', flex: 1 }}>{product.category}</p>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span className="price-tag">₹{product.price.toLocaleString('en-IN')}</span>
          <button className="btn btn-primary" onClick={handleAdd}>
            Add
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
